import { supabase } from "../supabase";

// Muting is one-directional and doesn't touch the follows table — unlike a
// block, the muted user isn't notified and keeps following/being followed
// normally, they just stop showing up in your own feed.
export async function getMutedUserIds(userId) {
  if (!userId) return [];

  const { data, error } = await supabase
    .from("mutes")
    .select("muted_id")
    .eq("muter_id", userId);

  if (error) {
    console.log("GET MUTED IDS ERROR:", error);
    return [];
  }

  return (data || []).map(r => r.muted_id);
}

export async function muteUser(muterId, mutedId) {
  const { error } = await supabase
    .from("mutes")
    .insert({ muter_id: muterId, muted_id: mutedId });

  return { error };
}

export async function unmuteUser(muterId, mutedId) {
  const { error } = await supabase
    .from("mutes")
    .delete()
    .eq("muter_id", muterId)
    .eq("muted_id", mutedId);

  return { error };
}

export async function checkMuteStatus(currentUserId, otherUserId) {
  if (!currentUserId || !otherUserId) return false;

  const { data } = await supabase
    .from("mutes")
    .select("id")
    .eq("muter_id", currentUserId)
    .eq("muted_id", otherUserId)
    .maybeSingle();

  return !!data;
}
